var exports = {
  "k": "x805b157e--90322b--container",
};

module.exports = exports;
